import { render, staticRenderFns } from "./PatentTradosUploadForm.vue?vue&type=template&id=08d444d3&"
import script from "./PatentTradosUploadForm.vue?vue&type=script&lang=js&"
export * from "./PatentTradosUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentTradosUploadForm.vue?vue&type=style&index=0&id=08d444d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports